export const cx = (...classNames: string[]): string => {
  return classNames.join(" ");
};
